import React from 'react';

export const BonusIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.6668 4.66667L8.00016 1.33334L2.3335 4.66667V11.3333L8.00016 14.6667L13.6668 11.3333V4.66667ZM8.00016 10.8571C9.54891 10.8571 10.8044 9.57796 10.8044 8C10.8044 6.42205 9.54891 5.14286 8.00016 5.14286C6.4514 5.14286 5.19588 6.42205 5.19588 8C5.19588 9.57796 6.4514 10.8571 8.00016 10.8571Z"
      fill="#FDC300"
    />
  </svg>
);
